import { render } from "./PlayerList.vue?vue&type=template&id=5b88965f"
import script from "./PlayerList.vue?vue&type=script&lang=js"
export * from "./PlayerList.vue?vue&type=script&lang=js"

import "./PlayerList.vue?vue&type=style&index=0&id=5b88965f&lang=css"

import exportComponent from "/github/workspace/timmies-helper-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__